import { Notification } from "@planzone/dto";

interface Props {
  notification: Notification;
  close?(): void;
}

enum NotificationType {
  MENTION_IN_COMMENT = "MENTION_IN_COMMENT",
  REPLY_TO_COMMENT = "REPLY_TO_COMMENT",
  ADDED_TO_TASK = "ADDED_TO_TASK",
  ADDED_TO_PROJECT = "ADDED_TO_PROJECT",
  ADDED_TO_EVENT = "ADDED_TO_EVENT",
  DELAYED_TASK = "DELAYED_TASK",
  EXPORT_BI_FINISHED = "EXPORT_BI_FINISHED",
}

type ConcreteNotification = Omit<Notification, "data"> &
  (
    | {
        type: NotificationType.MENTION_IN_COMMENT;
        data: {
          projectId: string;
          taskId: string;
          commentId: string;
          taskName: string;
          zoneName: string;
          authorName: string;
          projectName: string;
          listName: string;
          commentContent: string;
          zoneId: string;
          elementName: string;
          elementId: string;
          elementType: "ACTIVITY" | "TASK" | "MILESTONE" | "EVENT" | "PROJECT";
        };
      }
    | {
        type: NotificationType.REPLY_TO_COMMENT;
        data: {
          projectId: string;
          taskId: string;
          commentId: string;
          taskName: string;
          zoneName: string;
          authorName: string;
          projectName: string;
          listName: string;
          commentContent: string;
          zoneId: string;
          elementName: string;
          elementId: string;
          elementType: "ACTIVITY" | "TASK" | "MILESTONE" | "EVENT" | "PROJECT";
        };
      }
    | {
        type: NotificationType.ADDED_TO_TASK;
        data: {
          authorName: string;
          projectId: string;
          projectName: string;
          taskId: string;
          taskName: string;
          zoneID: string;
          zoneName: string;
        };
      }
    | {
        type: NotificationType.ADDED_TO_PROJECT;
        data: {
          authorName: string;
          projectId: string;
          projectName: string;
          zoneID: string;
          zoneName: string;
        };
      }
    | {
        type: NotificationType.ADDED_TO_EVENT;
        data: {
          projectName: string;
          authorName: string;
          eventName: string;
          projectId: string;
          eventId: string;
          zoneName: string;
          zoneID: string;
        };
      }
    | {
        type: NotificationType.DELAYED_TASK;
        data: {
          taskId: string;
          zoneId: string;
          taskName: string;
          projectId: string;
          projectName: string;
          zoneName: string;
        };
      }
    | {
        type: NotificationType.EXPORT_BI_FINISHED;
        data: {
          runId: string;
          planzoneId: string;
          status: "COMPLETED" | "PARTIAL" | "FAILED";
        };
      }
  );

export type { Props, ConcreteNotification };

export { NotificationType };
